import { useReadContract } from 'wagmi'
import { BaseVibeAbi } from '../utils/BaseVibeAbi'
import { CONTRACT_ADDRESS } from '../utils/constants'

/**
 * Hook to fetch on-chain bull/bear vote statistics for a user
 * @param address - The user's wallet address
 * @returns bullishVotes, bearishVotes, and refetch function
 */
export function useVoteStats(address: string | undefined) {
  const { data: voteStatsData, refetch } = useReadContract({
    address: CONTRACT_ADDRESS as `0x${string}`,
    abi: BaseVibeAbi,
    functionName: 'getUserVoteStats',
    args: address ? [address as `0x${string}`] : undefined,
    query: {
      enabled: !!address && CONTRACT_ADDRESS !== '0x0000000000000000000000000000000000000000',
      refetchInterval: 30000, // Refetch every 30 seconds
    },
  })

  const bullishVotes = voteStatsData ? Number(voteStatsData[0]) : 0
  const bearishVotes = voteStatsData ? Number(voteStatsData[1]) : 0

  const refreshVoteStats = async () => {
    await refetch()
  }

  return {
    bullishVotes,
    bearishVotes,
    refreshVoteStats,
  }
}

